export const baseUrl = 'https://www.googleapis.com/youtube/v3/'
export const apiKey = 'AIzaSyAOnURL-X5QAbwG4_3znBsdxFbvNqEqNVU'